/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum InterruptedPregnancyReason {
    HIGH_RISK_FOR_MOTHER_HEALTH = 'highRiskForMotherHealth',
    SEVERE_CHILD_CONGENITAL_MALFORMATION = 'severeChildCongenitalMalformation',
    OTHER_MEDICAL_REASONS = 'otherMedicalReasons',
}
